var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.25C13.4539 4.25 14.3211 5.87039 13.5146 7.08013C13.5052 7.0943 13.4956 7.10828 13.4859 7.12208C17.7494 7.83036 21 11.5356 21 16C21.5523 16 22 16.4477 22 17V18C22 18.0863 21.9891 18.1701 21.9685 18.25H22C22.4142 18.25 22.75 18.5858 22.75 19C22.75 19.4142 22.4142 19.75 22 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H2.0315C2.01094 18.1701 2 18.0863 2 18V17C2 16.4477 2.44772 16 3 16C3 11.5356 6.25062 7.83036 10.5141 7.12208C10.5044 7.10828 10.4948 7.0943 10.4854 7.08013C9.67887 5.87039 10.5461 4.25 12 4.25ZM12 5.75C11.7441 5.75 11.5915 6.03517 11.7334 6.24808C11.8602 6.43829 12.1398 6.43829 12.2666 6.24808C12.4085 6.03517 12.2559 5.75 12 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.b622a3397a77bbe8c36c538a8e02ff28.svg";
export { ForwardRef as ReactComponent };